import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Icons } from "../../assets";
import { useCalculator } from "../../hooks";
import { useQuery } from "@tanstack/react-query";

export default function CarbonImpact() {
  const [commuteFrequency, setCommuteFrequency] = useState(1);
  const navigate = useNavigate();
  const frequency = [
    {
      title: "Daily",
      frequnecy: 1,
    },
    {
      title: "weekly",
      frequnecy: 1,
    },
    {
      title: "Monthly",
      frequnecy: 4,
    },
    {
      title: "Yearly",
      frequnecy: 52,
    },
  ];
  const location = useLocation();
  const queryparams = new URLSearchParams(location.search);
  const { savings } = Object.fromEntries(queryparams.entries());
  if (!savings) {
    return (
      <div>
        <p>Page not found!</p>
      </div>
    );
  }

  const onClick = () => {
    navigate(
      `/companycarbonimpact?savings=${savings}&frequency=${commuteFrequency}`
    );
  };

  return (
    <div className="flex flex-1 h-[80vh] place-items-center p-16">
      <div className="flex flex-col gap-4 ">
        <p className="font-semibold">Your CO2 savings</p>
        <p className="font-bold text-5xl">Your Impact this year could be...</p>
        <p>what if you were to carpool to and from work a few days a week</p>
        <div className="flex flex-col gap-4">
          <p>How many days per week would you carpool?</p>
          <div className="flex gap-4 place-items-center">
            <p className="border p-2 rounded-lg py-2 px-4 w-[100px] text-center">
              {commuteFrequency} days
            </p>
            <input
              type="range"
              className="cursor-pointer w-1/2 h-1 appearance-none bg-gray-500"
              min={0}
              max={5}
              value={commuteFrequency}
              onChange={(e) => setCommuteFrequency(parseInt(e.target.value))}
              style={{
                accentColor: "black",
              }}
            />
          </div>
          <div
            className="flex gap-4 py-4 place-items-center cursor-pointer hover:text-gray-900"
            onClick={onClick}
          >
            <p>See company savings</p>
            <img src={Icons.chevron_down} className="w-2 h-2 -rotate-90" />
          </div>
        </div>
      </div>
      <div className="flex w-2/3 h-fit">
        <div className="grid grid-cols-2 gap-8 w-full">
          {frequency.map((f, index) => (
            <SavingsContainer
              frequency={f.title}
              savings={
                index == 0
                  ? parseFloat(savings) * 2 /** x2 for return trip */
                  : f.frequnecy * parseFloat(savings) * commuteFrequency * 2
              }
            />
          ))}
        </div>
      </div>
    </div>
  );
}
const SavingsContainer = ({
  frequency = "Daily",
  savings = 3,
  // description = "equivalent to driving 8 miles in a standard car",
}) => {
  const [animatedSavings, setAnimatedSavings] = useState(0);
  const { getSavingsPrompt } = useCalculator();

  const { data: description = "" } = useQuery({
    queryKey: ["savings", savings],
    queryFn: () => getSavingsPrompt(savings + "kg"),
    enabled: !!savings,
  });

  useEffect(() => {
    let start = animatedSavings; // Start from the current animatedSavings value
    const duration = 500;
    const frameRate = 16;
    const increment = Math.abs(savings - start) / (duration / frameRate); // Calculate increment per frame

    const interval = setInterval(() => {
      if (savings > 100) savings = savings / 1000;
      if (start < savings) {
        start = Math.min(start + increment, savings);
      } else if (start > savings) {
        start = Math.max(start - increment, savings);
      }

      setAnimatedSavings(Number(start)); // Update animated savings

      if (start === savings) {
        clearInterval(interval);
      }
    }, frameRate);

    return () => clearInterval(interval); // Cleanup interval
  }, [savings]);

  return (
    <div className="flex flex-col w-full h-full border border-black rounded-2xl p-8">
      <p className="font-bold xl:text-xl md:text-lg">{frequency}</p>
      <div className="flex flex-1 flex-col justify-end place-items-end gap-4 pt-8">
        <p className="font-bold xl:text-5xl md:text-4xl ">
          {animatedSavings.toFixed(2)}
          {savings > 100 ? "t" : "Kg"}
        </p>
        <div className="w-full border-[0.5px] border-black" />
        <p className="xl:text-sm md:text-xs font-normal">
          {description || " "}
        </p>
      </div>
    </div>
  );
};
